const PTZService = {
    movePTZ: async (direction,server_name="", speed = 1.0,timeout = 1) => {
        try {
            const response = await fetch(server_name+'/ptz', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    direction,
                    speed,
                    timeout
                })
            });

            if (!response.ok) {
                throw new Error('Failed to move PTZ');
            }

            return response.json();
        } catch (error) {
            console.error('Failed to move PTZ', error);
            throw error; // Re-throw the error for handling in the UI or other parts of your application
        }
    },
    gotoHomePTZ: async (server_name="") => {
        try {
            const response = await fetch(server_name+'/ptz_service', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                })
            });

            if (!response.ok) {
                throw new Error('Failed to gotoHome PTZ');
            }

            return response.json();
        } catch (error) {
            console.error('Failed to move PTZ', error);
            throw error; // Re-throw the error for handling in the UI or other parts of your application
        }
    }
    ,
    snapshotPTZ: async (server_name="") => {
        try {
            const response = await fetch(server_name+'/ptz_snapshot', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                })
            });

            if (!response.ok) {
                throw new Error('Failed to gotoHome PTZ');
            }

            return response.json();
        } catch (error) {
            console.error('Failed to move PTZ', error);
            throw error; // Re-throw the error for handling in the UI or other parts of your application
        }
    },
    gotoPreset: async (preset,server_name="", speed = 1.0,timeout = 1) => {
        try {
            const response = await fetch(server_name+'/go_to_preset', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    preset,
                    speed,
                    timeout
                })
            });

            if (!response.ok) {
                throw new Error('Failed to go to preset PTZ');
            }

            return response.json();
        } catch (error) {
            console.error('Failed to go to PTZ', error);
            throw error; // Re-throw the error for handling in the UI or other parts of your application
        }
    },
    setPreset: async (preset,server_name="",timeout = 1) => {
        try {
            const response = await fetch(server_name+'/set_preset', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    preset,
                    timeout
                })
            });

            if (!response.ok) {
                throw new Error('Failed to set preset PTZ');
            }

            return response.json();
        } catch (error) {
            console.error('Failed to set preset PTZ', error);
            throw error; // Re-throw the error for handling in the UI or other parts of your application
        }
    },
    wipeLens: async (server_name="",timeout = 1) => {
        try {
            const response = await fetch(server_name+'/wipe_lens', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    timeout
                })
            });

            if (!response.ok) {
                throw new Error('Failed to set preset PTZ');
            }

            return response.json();
        } catch (error) {
            console.error('Failed to set preset PTZ', error);
            throw error; // Re-throw the error for handling in the UI or other parts of your application
        }
    },
    gotoAngle: async (pan, tilt, zoom, server_name="", speed = 1.0,timeout = 1) => {
        try {
            const response = await fetch(server_name+'/go_to_angle', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    pan,
                    tilt,
                    zoom,
                    speed,
                    timeout
                })
            });

            if (!response.ok) {
                throw new Error('Failed to go to preset PTZ');
            }

            return response.json();
        } catch (error) {
            console.error('Failed to go to PTZ', error);
            throw error; // Re-throw the error for handling in the UI or other parts of your application
        }
    },
    getAngle: async (server_name="") => {
        try {
            const response = await fetch(server_name+'/get_angle', {
                method: 'Get'
            });

            if (!response.ok) {
                throw new Error('Failed to go to preset PTZ');
            }

            return response.json();
        } catch (error) {
            console.error('Failed to go to PTZ', error);
            throw error; // Re-throw the error for handling in the UI or other parts of your application
        }
    }
};

export default PTZService;
